import { Button, Snackbar, Alert, Fade } from "@mui/material";
import { useState } from "react";
import axiosInstance from "../../features/axiosInstance/axiosInstance";
import { AxiosError } from "axios";

interface ErrorResponse {
  message: string;
}

const RunImportButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success" as "success" | "warning" | "error",
  });

  const handleImport = async () => {
    try {
      setIsLoading(true);
      await axiosInstance.post("/projects/import/actual");
      setNotification({
        open: true,
        message: "Import started",
        severity: "success",
      });
    } catch (error) {
      console.error("Import failed:", error);
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response?.status === 409) {
        setNotification({
          open: true,
          message: axiosError.response.data.toString(),
          severity: "warning",
        });
      } else {
        setNotification({
          open: true,
          message: "Import failed to start",
          severity: "error",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  return (
    <>
      <Button
        onClick={handleImport}
        disabled={isLoading}
        variant="outlined"
        sx={{ height: "40px" }}
      >
        {isLoading ? "Importing..." : "Run Import"}
      </Button>
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        TransitionComponent={Fade}
        transitionDuration={{ enter: 300, exit: 300 }}
      >
        <Alert
          severity={notification.severity}
          onClose={handleCloseNotification}
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default RunImportButton;
